export type AccountStatus = 'normal' | 'checking' | 'warning' | 'unavailable';

export interface AccountRecord {
  id: string;
  maskedAccount: string;
  region: string;
  regionCode: string;
  status: AccountStatus;
  checkedAt: string;
  sourceLabel: string;
  description: string;
  mockAccountValue: string;
  mockPasswordValue: string;
  tab: 1 | 2;
}

export const mockAccounts: AccountRecord[] = [
  {
    id: 'acc-001',
    maskedAccount: 'sh***w@icloud.com',
    region: 'Hoa Kỳ',
    regionCode: 'US',
    status: 'normal',
    checkedAt: '2026-03-13 05:30:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Tài khoản US ổn định, hỗ trợ Shadowrocket',
    mockAccountValue: 'sh***w@icloud.com',
    mockPasswordValue: 'Mock@Pass01',
    tab: 1,
  },
  {
    id: 'acc-002',
    maskedAccount: 'vn***pro@icloud.com',
    region: 'Việt Nam',
    regionCode: 'VN',
    status: 'normal',
    checkedAt: '2026-03-13 05:28:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Việt Nam, đã xác minh hoạt động',
    mockAccountValue: 'vn***pro@icloud.com',
    mockPasswordValue: 'Mock@Pass02',
    tab: 1,
  },
  {
    id: 'acc-003',
    maskedAccount: 'hk***88@icloud.com',
    region: 'Hồng Kông',
    regionCode: 'HK',
    status: 'checking',
    checkedAt: '2026-03-13 05:25:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Đang kiểm tra lại trạng thái',
    mockAccountValue: 'hk***88@icloud.com',
    mockPasswordValue: 'Mock@Pass03',
    tab: 1,
  },
  {
    id: 'acc-004',
    maskedAccount: 'jp***sakura@icloud.com',
    region: 'Nhật Bản',
    regionCode: 'JP',
    status: 'normal',
    checkedAt: '2026-03-13 05:22:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Nhật Bản tốc độ cao',
    mockAccountValue: 'jp***sakura@icloud.com',
    mockPasswordValue: 'Mock@Pass04',
    tab: 1,
  },
  {
    id: 'acc-005',
    maskedAccount: 'kr***seoul@icloud.com',
    region: 'Hàn Quốc',
    regionCode: 'KR',
    status: 'normal',
    checkedAt: '2026-03-13 05:20:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Hàn Quốc, hoạt động tốt',
    mockAccountValue: 'kr***seoul@icloud.com',
    mockPasswordValue: 'Mock@Pass05',
    tab: 1,
  },
  {
    id: 'acc-006',
    maskedAccount: 'us***alpha@icloud.com',
    region: 'Hoa Kỳ',
    regionCode: 'US',
    status: 'warning',
    checkedAt: '2026-03-13 05:18:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Lưu ý: tải lần lượt, không đồng thời',
    mockAccountValue: 'us***alpha@icloud.com',
    mockPasswordValue: 'Mock@Pass06',
    tab: 1,
  },
  {
    id: 'acc-007',
    maskedAccount: 'tw***cloud@icloud.com',
    region: 'Đài Loan',
    regionCode: 'TW',
    status: 'normal',
    checkedAt: '2026-03-13 05:15:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Đài Loan ổn định',
    mockAccountValue: 'tw***cloud@icloud.com',
    mockPasswordValue: 'Mock@Pass07',
    tab: 1,
  },
  {
    id: 'acc-008',
    maskedAccount: 'sg***lion@icloud.com',
    region: 'Singapore',
    regionCode: 'SG',
    status: 'normal',
    checkedAt: '2026-03-13 05:12:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Singapore, ping thấp',
    mockAccountValue: 'sg***lion@icloud.com',
    mockPasswordValue: 'Mock@Pass08',
    tab: 1,
  },
  {
    id: 'acc-009',
    maskedAccount: 'au***down@icloud.com',
    region: 'Úc',
    regionCode: 'AU',
    status: 'unavailable',
    checkedAt: '2026-03-13 04:50:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Tạm thời không khả dụng',
    mockAccountValue: 'au***down@icloud.com',
    mockPasswordValue: 'Mock@Pass09',
    tab: 1,
  },
  {
    id: 'acc-010',
    maskedAccount: 'uk***brit@icloud.com',
    region: 'Anh Quốc',
    regionCode: 'UK',
    status: 'normal',
    checkedAt: '2026-03-13 05:08:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Anh, cập nhật hôm nay',
    mockAccountValue: 'uk***brit@icloud.com',
    mockPasswordValue: 'Mock@Pass10',
    tab: 1,
  },
  {
    id: 'acc-011',
    maskedAccount: 'fr***paris@icloud.com',
    region: 'Pháp',
    regionCode: 'FR',
    status: 'checking',
    checkedAt: '2026-03-13 05:05:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Đang xác minh kết nối',
    mockAccountValue: 'fr***paris@icloud.com',
    mockPasswordValue: 'Mock@Pass11',
    tab: 1,
  },
  {
    id: 'acc-012',
    maskedAccount: 'tr***istan@icloud.com',
    region: 'Thổ Nhĩ Kỳ',
    regionCode: 'TR',
    status: 'normal',
    checkedAt: '2026-03-13 05:02:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Thổ Nhĩ Kỳ giá rẻ',
    mockAccountValue: 'tr***istan@icloud.com',
    mockPasswordValue: 'Mock@Pass12',
    tab: 1,
  },
  {
    id: 'acc-013',
    maskedAccount: 'my***kl@icloud.com',
    region: 'Malaysia',
    regionCode: 'MY',
    status: 'normal',
    checkedAt: '2026-03-13 04:58:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Malaysia, hoạt động bình thường',
    mockAccountValue: 'my***kl@icloud.com',
    mockPasswordValue: 'Mock@Pass13',
    tab: 1,
  },
  {
    id: 'acc-014',
    maskedAccount: 'th***bkk@icloud.com',
    region: 'Thái Lan',
    regionCode: 'TH',
    status: 'warning',
    checkedAt: '2026-03-13 04:55:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Dùng nhanh, tránh thay đổi cài đặt',
    mockAccountValue: 'th***bkk@icloud.com',
    mockPasswordValue: 'Mock@Pass14',
    tab: 1,
  },
  {
    id: 'acc-015',
    maskedAccount: 'ru***msk@icloud.com',
    region: 'Nga',
    regionCode: 'RU',
    status: 'normal',
    checkedAt: '2026-03-13 04:52:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Nga, đã kiểm tra hôm nay',
    mockAccountValue: 'ru***msk@icloud.com',
    mockPasswordValue: 'Mock@Pass15',
    tab: 1,
  },
  // Tab 2 records
  {
    id: 'acc-101',
    maskedAccount: 'bk***us2@icloud.com',
    region: 'Hoa Kỳ',
    regionCode: 'US',
    status: 'normal',
    checkedAt: '2026-03-13 05:29:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng US, ổn định',
    mockAccountValue: 'bk***us2@icloud.com',
    mockPasswordValue: 'Mock@Bk01',
    tab: 2,
  },
  {
    id: 'acc-102',
    maskedAccount: 'bk***jp2@icloud.com',
    region: 'Nhật Bản',
    regionCode: 'JP',
    status: 'normal',
    checkedAt: '2026-03-13 05:27:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Nhật Bản',
    mockAccountValue: 'bk***jp2@icloud.com',
    mockPasswordValue: 'Mock@Bk02',
    tab: 2,
  },
  {
    id: 'acc-103',
    maskedAccount: 'bk***hk2@icloud.com',
    region: 'Hồng Kông',
    regionCode: 'HK',
    status: 'checking',
    checkedAt: '2026-03-13 05:24:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Đang kiểm tra nguồn HK2',
    mockAccountValue: 'bk***hk2@icloud.com',
    mockPasswordValue: 'Mock@Bk03',
    tab: 2,
  },
  {
    id: 'acc-104',
    maskedAccount: 'bk***sg2@icloud.com',
    region: 'Singapore',
    regionCode: 'SG',
    status: 'normal',
    checkedAt: '2026-03-13 05:21:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Singapore dự phòng, tốc độ cao',
    mockAccountValue: 'bk***sg2@icloud.com',
    mockPasswordValue: 'Mock@Bk04',
    tab: 2,
  },
  {
    id: 'acc-105',
    maskedAccount: 'bk***kr2@icloud.com',
    region: 'Hàn Quốc',
    regionCode: 'KR',
    status: 'normal',
    checkedAt: '2026-03-13 05:18:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng KR2',
    mockAccountValue: 'bk***kr2@icloud.com',
    mockPasswordValue: 'Mock@Bk05',
    tab: 2,
  },
  {
    id: 'acc-106',
    maskedAccount: 'bk***tw2@icloud.com',
    region: 'Đài Loan',
    regionCode: 'TW',
    status: 'warning',
    checkedAt: '2026-03-13 05:10:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Dùng cẩn thận, kiểm tra trước',
    mockAccountValue: 'bk***tw2@icloud.com',
    mockPasswordValue: 'Mock@Bk06',
    tab: 2,
  },
  {
    id: 'acc-107',
    maskedAccount: 'bk***vn2@icloud.com',
    region: 'Việt Nam',
    regionCode: 'VN',
    status: 'normal',
    checkedAt: '2026-03-13 05:07:00',
    sourceLabel: 'ShadowID · S2',
    description: 'ID VN dự phòng, hoạt động tốt',
    mockAccountValue: 'bk***vn2@icloud.com',
    mockPasswordValue: 'Mock@Bk07',
    tab: 2,
  },
  // --- 50 tài khoản bổ sung ---
  {
    id: 'acc-016',
    maskedAccount: 'de***berlin@icloud.com',
    region: 'Đức',
    regionCode: 'DE',
    status: 'normal',
    checkedAt: '2026-03-13 04:48:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Đức, kết nối ổn định',
    mockAccountValue: 'de***berlin@icloud.com',
    mockPasswordValue: 'Mock@Pass16',
    tab: 1,
  },
  {
    id: 'acc-017',
    maskedAccount: 'ca***maple@icloud.com',
    region: 'Canada',
    regionCode: 'CA',
    status: 'normal',
    checkedAt: '2026-03-13 04:45:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Canada, đã xác minh hôm nay',
    mockAccountValue: 'ca***maple@icloud.com',
    mockPasswordValue: 'Mock@Pass17',
    tab: 1,
  },
  {
    id: 'acc-018',
    maskedAccount: 'nl***ams@icloud.com',
    region: 'Hà Lan',
    regionCode: 'NL',
    status: 'checking',
    checkedAt: '2026-03-13 04:42:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Đang kiểm tra kết nối Hà Lan',
    mockAccountValue: 'nl***ams@icloud.com',
    mockPasswordValue: 'Mock@Pass18',
    tab: 1,
  },
  {
    id: 'acc-019',
    maskedAccount: 'in***mum@icloud.com',
    region: 'Ấn Độ',
    regionCode: 'IN',
    status: 'normal',
    checkedAt: '2026-03-13 04:40:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Ấn Độ, hoạt động bình thường',
    mockAccountValue: 'in***mum@icloud.com',
    mockPasswordValue: 'Mock@Pass19',
    tab: 1,
  },
  {
    id: 'acc-020',
    maskedAccount: 'br***rio@icloud.com',
    region: 'Brazil',
    regionCode: 'BR',
    status: 'warning',
    checkedAt: '2026-03-13 04:38:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Lưu ý: tốc độ có thể chậm giờ cao điểm',
    mockAccountValue: 'br***rio@icloud.com',
    mockPasswordValue: 'Mock@Pass20',
    tab: 1,
  },
  {
    id: 'acc-021',
    maskedAccount: 'it***rome@icloud.com',
    region: 'Ý',
    regionCode: 'IT',
    status: 'normal',
    checkedAt: '2026-03-13 04:35:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Ý, ping thấp, ổn định',
    mockAccountValue: 'it***rome@icloud.com',
    mockPasswordValue: 'Mock@Pass21',
    tab: 1,
  },
  {
    id: 'acc-022',
    maskedAccount: 'es***mad@icloud.com',
    region: 'Tây Ban Nha',
    regionCode: 'ES',
    status: 'normal',
    checkedAt: '2026-03-13 04:32:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Tây Ban Nha, hoạt động tốt',
    mockAccountValue: 'es***mad@icloud.com',
    mockPasswordValue: 'Mock@Pass22',
    tab: 1,
  },
  {
    id: 'acc-023',
    maskedAccount: 'ph***mnl@icloud.com',
    region: 'Philippines',
    regionCode: 'PH',
    status: 'normal',
    checkedAt: '2026-03-13 04:30:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Philippines, đã kiểm tra',
    mockAccountValue: 'ph***mnl@icloud.com',
    mockPasswordValue: 'Mock@Pass23',
    tab: 1,
  },
  {
    id: 'acc-024',
    maskedAccount: 'id***jkt@icloud.com',
    region: 'Indonesia',
    regionCode: 'ID',
    status: 'checking',
    checkedAt: '2026-03-13 04:28:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Đang xác minh ID Indonesia',
    mockAccountValue: 'id***jkt@icloud.com',
    mockPasswordValue: 'Mock@Pass24',
    tab: 1,
  },
  {
    id: 'acc-025',
    maskedAccount: 'se***stk@icloud.com',
    region: 'Thụy Điển',
    regionCode: 'SE',
    status: 'normal',
    checkedAt: '2026-03-13 04:25:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Thụy Điển, tốc độ cao',
    mockAccountValue: 'se***stk@icloud.com',
    mockPasswordValue: 'Mock@Pass25',
    tab: 1,
  },
  {
    id: 'acc-026',
    maskedAccount: 'ch***zur@icloud.com',
    region: 'Thụy Sĩ',
    regionCode: 'CH',
    status: 'normal',
    checkedAt: '2026-03-13 04:22:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Thụy Sĩ, bảo mật cao',
    mockAccountValue: 'ch***zur@icloud.com',
    mockPasswordValue: 'Mock@Pass26',
    tab: 1,
  },
  {
    id: 'acc-027',
    maskedAccount: 'mx***cdmx@icloud.com',
    region: 'Mexico',
    regionCode: 'MX',
    status: 'unavailable',
    checkedAt: '2026-03-13 03:50:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Tạm ngưng, đang bảo trì',
    mockAccountValue: 'mx***cdmx@icloud.com',
    mockPasswordValue: 'Mock@Pass27',
    tab: 1,
  },
  {
    id: 'acc-028',
    maskedAccount: 'ar***bue@icloud.com',
    region: 'Argentina',
    regionCode: 'AR',
    status: 'normal',
    checkedAt: '2026-03-13 04:18:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Argentina, hoạt động ổn',
    mockAccountValue: 'ar***bue@icloud.com',
    mockPasswordValue: 'Mock@Pass28',
    tab: 1,
  },
  {
    id: 'acc-029',
    maskedAccount: 'za***jhb@icloud.com',
    region: 'Nam Phi',
    regionCode: 'ZA',
    status: 'warning',
    checkedAt: '2026-03-13 04:15:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Ping cao, dùng khi cần thiết',
    mockAccountValue: 'za***jhb@icloud.com',
    mockPasswordValue: 'Mock@Pass29',
    tab: 1,
  },
  {
    id: 'acc-030',
    maskedAccount: 'ae***dxb@icloud.com',
    region: 'UAE',
    regionCode: 'AE',
    status: 'normal',
    checkedAt: '2026-03-13 04:12:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID UAE, kết nối tốt',
    mockAccountValue: 'ae***dxb@icloud.com',
    mockPasswordValue: 'Mock@Pass30',
    tab: 1,
  },
  {
    id: 'acc-031',
    maskedAccount: 'no***osl@icloud.com',
    region: 'Na Uy',
    regionCode: 'NO',
    status: 'normal',
    checkedAt: '2026-03-13 04:10:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Na Uy, ổn định',
    mockAccountValue: 'no***osl@icloud.com',
    mockPasswordValue: 'Mock@Pass31',
    tab: 1,
  },
  {
    id: 'acc-032',
    maskedAccount: 'fi***hel@icloud.com',
    region: 'Phần Lan',
    regionCode: 'FI',
    status: 'checking',
    checkedAt: '2026-03-13 04:08:00',
    sourceLabel: 'ShadowID · S1',
    description: 'Đang kiểm tra ID Phần Lan',
    mockAccountValue: 'fi***hel@icloud.com',
    mockPasswordValue: 'Mock@Pass32',
    tab: 1,
  },
  {
    id: 'acc-033',
    maskedAccount: 'pl***waw@icloud.com',
    region: 'Ba Lan',
    regionCode: 'PL',
    status: 'normal',
    checkedAt: '2026-03-13 04:05:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Ba Lan, hoạt động bình thường',
    mockAccountValue: 'pl***waw@icloud.com',
    mockPasswordValue: 'Mock@Pass33',
    tab: 1,
  },
  {
    id: 'acc-034',
    maskedAccount: 'nz***akl@icloud.com',
    region: 'New Zealand',
    regionCode: 'NZ',
    status: 'normal',
    checkedAt: '2026-03-13 04:02:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID New Zealand, tốc độ tốt',
    mockAccountValue: 'nz***akl@icloud.com',
    mockPasswordValue: 'Mock@Pass34',
    tab: 1,
  },
  {
    id: 'acc-035',
    maskedAccount: 'pt***lis@icloud.com',
    region: 'Bồ Đào Nha',
    regionCode: 'PT',
    status: 'normal',
    checkedAt: '2026-03-13 04:00:00',
    sourceLabel: 'ShadowID · S1',
    description: 'ID Bồ Đào Nha, đã xác minh',
    mockAccountValue: 'pt***lis@icloud.com',
    mockPasswordValue: 'Mock@Pass35',
    tab: 1,
  },
  // Tab 2 bổ sung
  {
    id: 'acc-108',
    maskedAccount: 'bk***de2@icloud.com',
    region: 'Đức',
    regionCode: 'DE',
    status: 'normal',
    checkedAt: '2026-03-13 05:05:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Đức, ổn định',
    mockAccountValue: 'bk***de2@icloud.com',
    mockPasswordValue: 'Mock@Bk08',
    tab: 2,
  },
  {
    id: 'acc-109',
    maskedAccount: 'bk***ca2@icloud.com',
    region: 'Canada',
    regionCode: 'CA',
    status: 'normal',
    checkedAt: '2026-03-13 05:03:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Canada',
    mockAccountValue: 'bk***ca2@icloud.com',
    mockPasswordValue: 'Mock@Bk09',
    tab: 2,
  },
  {
    id: 'acc-110',
    maskedAccount: 'bk***au2@icloud.com',
    region: 'Úc',
    regionCode: 'AU',
    status: 'checking',
    checkedAt: '2026-03-13 05:00:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Đang kiểm tra nguồn AU2',
    mockAccountValue: 'bk***au2@icloud.com',
    mockPasswordValue: 'Mock@Bk10',
    tab: 2,
  },
  {
    id: 'acc-111',
    maskedAccount: 'bk***fr2@icloud.com',
    region: 'Pháp',
    regionCode: 'FR',
    status: 'normal',
    checkedAt: '2026-03-13 04:58:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Pháp, hoạt động tốt',
    mockAccountValue: 'bk***fr2@icloud.com',
    mockPasswordValue: 'Mock@Bk11',
    tab: 2,
  },
  {
    id: 'acc-112',
    maskedAccount: 'bk***uk2@icloud.com',
    region: 'Anh Quốc',
    regionCode: 'GB',
    status: 'normal',
    checkedAt: '2026-03-13 04:55:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng UK2, ổn định',
    mockAccountValue: 'bk***uk2@icloud.com',
    mockPasswordValue: 'Mock@Bk12',
    tab: 2,
  },
  {
    id: 'acc-113',
    maskedAccount: 'bk***in2@icloud.com',
    region: 'Ấn Độ',
    regionCode: 'IN',
    status: 'warning',
    checkedAt: '2026-03-13 04:52:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Dùng cẩn thận, kiểm tra trước khi dùng',
    mockAccountValue: 'bk***in2@icloud.com',
    mockPasswordValue: 'Mock@Bk13',
    tab: 2,
  },
  {
    id: 'acc-114',
    maskedAccount: 'bk***se2@icloud.com',
    region: 'Thụy Điển',
    regionCode: 'SE',
    status: 'normal',
    checkedAt: '2026-03-13 04:50:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Thụy Điển',
    mockAccountValue: 'bk***se2@icloud.com',
    mockPasswordValue: 'Mock@Bk14',
    tab: 2,
  },
  {
    id: 'acc-115',
    maskedAccount: 'bk***nl2@icloud.com',
    region: 'Hà Lan',
    regionCode: 'NL',
    status: 'normal',
    checkedAt: '2026-03-13 04:47:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Hà Lan, tốc độ cao',
    mockAccountValue: 'bk***nl2@icloud.com',
    mockPasswordValue: 'Mock@Bk15',
    tab: 2,
  },
  {
    id: 'acc-116',
    maskedAccount: 'bk***ph2@icloud.com',
    region: 'Philippines',
    regionCode: 'PH',
    status: 'normal',
    checkedAt: '2026-03-13 04:44:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Philippines',
    mockAccountValue: 'bk***ph2@icloud.com',
    mockPasswordValue: 'Mock@Bk16',
    tab: 2,
  },
  {
    id: 'acc-117',
    maskedAccount: 'bk***my2@icloud.com',
    region: 'Malaysia',
    regionCode: 'MY',
    status: 'checking',
    checkedAt: '2026-03-13 04:41:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Đang xác minh nguồn MY2',
    mockAccountValue: 'bk***my2@icloud.com',
    mockPasswordValue: 'Mock@Bk17',
    tab: 2,
  },
  {
    id: 'acc-118',
    maskedAccount: 'bk***th2@icloud.com',
    region: 'Thái Lan',
    regionCode: 'TH',
    status: 'normal',
    checkedAt: '2026-03-13 04:38:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Thái Lan',
    mockAccountValue: 'bk***th2@icloud.com',
    mockPasswordValue: 'Mock@Bk18',
    tab: 2,
  },
  {
    id: 'acc-119',
    maskedAccount: 'bk***ru2@icloud.com',
    region: 'Nga',
    regionCode: 'RU',
    status: 'unavailable',
    checkedAt: '2026-03-13 03:30:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Tạm ngưng, đang bảo trì',
    mockAccountValue: 'bk***ru2@icloud.com',
    mockPasswordValue: 'Mock@Bk19',
    tab: 2,
  },
  {
    id: 'acc-120',
    maskedAccount: 'bk***ae2@icloud.com',
    region: 'UAE',
    regionCode: 'AE',
    status: 'normal',
    checkedAt: '2026-03-13 04:35:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng UAE, kết nối tốt',
    mockAccountValue: 'bk***ae2@icloud.com',
    mockPasswordValue: 'Mock@Bk20',
    tab: 2,
  },
  {
    id: 'acc-121',
    maskedAccount: 'bk***tr2@icloud.com',
    region: 'Thổ Nhĩ Kỳ',
    regionCode: 'TR',
    status: 'normal',
    checkedAt: '2026-03-13 04:32:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Thổ Nhĩ Kỳ',
    mockAccountValue: 'bk***tr2@icloud.com',
    mockPasswordValue: 'Mock@Bk21',
    tab: 2,
  },
  {
    id: 'acc-122',
    maskedAccount: 'bk***id2@icloud.com',
    region: 'Indonesia',
    regionCode: 'ID',
    status: 'normal',
    checkedAt: '2026-03-13 04:29:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Indonesia',
    mockAccountValue: 'bk***id2@icloud.com',
    mockPasswordValue: 'Mock@Bk22',
    tab: 2,
  },
  {
    id: 'acc-123',
    maskedAccount: 'bk***ch2@icloud.com',
    region: 'Thụy Sĩ',
    regionCode: 'CH',
    status: 'normal',
    checkedAt: '2026-03-13 04:26:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Thụy Sĩ, bảo mật cao',
    mockAccountValue: 'bk***ch2@icloud.com',
    mockPasswordValue: 'Mock@Bk23',
    tab: 2,
  },
  {
    id: 'acc-124',
    maskedAccount: 'bk***nz2@icloud.com',
    region: 'New Zealand',
    regionCode: 'NZ',
    status: 'checking',
    checkedAt: '2026-03-13 04:23:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Đang kiểm tra nguồn NZ2',
    mockAccountValue: 'bk***nz2@icloud.com',
    mockPasswordValue: 'Mock@Bk24',
    tab: 2,
  },
  {
    id: 'acc-125',
    maskedAccount: 'bk***br2@icloud.com',
    region: 'Brazil',
    regionCode: 'BR',
    status: 'warning',
    checkedAt: '2026-03-13 04:20:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Dùng cẩn thận, ping có thể cao',
    mockAccountValue: 'bk***br2@icloud.com',
    mockPasswordValue: 'Mock@Bk25',
    tab: 2,
  },
  {
    id: 'acc-126',
    maskedAccount: 'bk***it2@icloud.com',
    region: 'Ý',
    regionCode: 'IT',
    status: 'normal',
    checkedAt: '2026-03-13 04:17:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Ý, hoạt động tốt',
    mockAccountValue: 'bk***it2@icloud.com',
    mockPasswordValue: 'Mock@Bk26',
    tab: 2,
  },
  {
    id: 'acc-127',
    maskedAccount: 'bk***es2@icloud.com',
    region: 'Tây Ban Nha',
    regionCode: 'ES',
    status: 'normal',
    checkedAt: '2026-03-13 04:14:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Tây Ban Nha',
    mockAccountValue: 'bk***es2@icloud.com',
    mockPasswordValue: 'Mock@Bk27',
    tab: 2,
  },
  {
    id: 'acc-128',
    maskedAccount: 'bk***pl2@icloud.com',
    region: 'Ba Lan',
    regionCode: 'PL',
    status: 'normal',
    checkedAt: '2026-03-13 04:11:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Ba Lan',
    mockAccountValue: 'bk***pl2@icloud.com',
    mockPasswordValue: 'Mock@Bk28',
    tab: 2,
  },
  {
    id: 'acc-129',
    maskedAccount: 'bk***no2@icloud.com',
    region: 'Na Uy',
    regionCode: 'NO',
    status: 'normal',
    checkedAt: '2026-03-13 04:08:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Na Uy, ổn định',
    mockAccountValue: 'bk***no2@icloud.com',
    mockPasswordValue: 'Mock@Bk29',
    tab: 2,
  },
  {
    id: 'acc-130',
    maskedAccount: 'bk***za2@icloud.com',
    region: 'Nam Phi',
    regionCode: 'ZA',
    status: 'normal',
    checkedAt: '2026-03-13 04:05:00',
    sourceLabel: 'ShadowID · S2',
    description: 'Nguồn dự phòng Nam Phi',
    mockAccountValue: 'bk***za2@icloud.com',
    mockPasswordValue: 'Mock@Bk30',
    tab: 2,
  },
];